const product = {
  product: "Sản phẩm", // translated 
  products: "Các sản phẩm", // translated 
  information: "Thông tin", // translated 
  additionalInformation: "Thông tin bổ sung", // translated 
  contactUs: "Liên hệ với chúng tôi", // translated 
  contactUsText: "Bạn muốn tùy chỉnh tour của mình hoặc có bất kỳ câu hỏi nào khác?", // translated 
  dropUsAnEmail: "Hãy gửi email cho chúng tôi", // translated 
  viewLess: "Xem ít hơn", // translated 
  viewMore: "Xem thêm", // translated 
  less: "ít hơn", // translated 
  more: "hơn", // translated 
  highlights: "Điểm nổi bật", // translated 
  inclusions: "Bao gồm", // translated 
  exclusions: "Các trường hợp ngoại lệ", // translated 
  pleaseWait: "Vui lòng chờ...", // translated 
  tourType: "Loại hình tour du lịch", // translated 
  search: "Tìm kiếm", // translated 
  available: "Có sẵn", // translated 
  availableTours: "Các tour du lịch có sẵn", // translated 
  sortBy: "SẮP XẾP THEO", // translated 
  priceLowToHigh: "Giá: Từ thấp đến cao", // translated 
  priceHighToLow: "Giá: Từ cao đến thấp", // translated 
  mostPopular: "Phổ biến nhất", // translated 
  roomOnly: "Chỉ bao phòng", // translated 
  bedAndBreakfast: "Nhà nghỉ B&B", // translated 
  halfBoard: "Bao ăn sáng và tối", // translated 
  fullBoard: "Bao ăn ở trọn gói", // translated 
  allInclusive: "Bao trọn gói", // translated 
  viewDetails: "Xem chi tiết", // translated 
  close: "Đóng", // translated 
  at: "Tại", // At dat, // translated 
  person: "người", // translated 
  cancellationPolicy: "Chính sách hủy bỏ", // translated 
  cancellationIs: "việc hủy bỏ là", // translated 
  to: "ĐẾN", // translated 
  bookingRemarks: "Ghi chú đặt phòng", // translated 
  totalPrice: "Tổng giá", // translated 
  back: "Mặt sau", // translated 
  bookNow: "Đặt ngay", // translated 
  minutes: "Phút", // translated 
  visitDuration: "Thời gian tham quan", // translated 
  itinerary: "Lịch trình", // translated 
  airportToHotel: "Từ sân bay đến khách sạn", // translated 
  hotelToAirport: "Từ khách sạn đến sân bay", // translated 
  details: "chi tiết", // translated 
  servicesDetails: "Chi tiết dịch vụ", // translated 
  services: "Dịch vụ", // translated 
  day: "Ngày", // translated 
  next: "Kế tiếp", // translated 
  nextStep: "Bước tiếp theo", // translated 
  skip: "Nhảy", // translated 
  remarks: "Ghi chú", // translated 
  optional: "không bắt buộc", // translated 
  guests: "Khách", // translated 
  payment: "Sự chi trả", // translated 
  pickup: "nhặt lên", // translated 
  featuredPackage: "Gói nổi bật", // translated 
  flights: "Các chuyến bay", // translated 
  accommodation: "Chỗ ở", // translated 
  transfers: "Chuyển nhượng", // translated 
  tours: "Các tour du lịch", // translated 
  experiences: "Trải nghiệm", // translated 
  featuredTour: "Chuyến tham quan nổi bật", // translated 
  From: "Từ", // translated 
  Accommodation: "Chỗ ở", // translated 
  approxDuration: "Thời gian ước tính", // translated 
  travellerInformation: "Thông tin dành cho du khách", // translated 
  bookingOverview: "Tổng quan về đặt chỗ", // translated 
  checkout: "Thanh toán", // translated 
  paymentFailed: "Thanh toán thất bại", // translated 
  paymentSuccess: "Thanh toán thành công", // translated 
  night: "Đêm", // translated 
  nights: "Đêm", // translated 
  viewEscapes: "View Escape", // translated 
  viewExperience: "Xem trải nghiệm", // translated 
  escapeType: "Loại thoát", // translated 
  adultsOnly: "Chỉ dành cho người lớn", // translated 
  totalDuration: "Tổng thời lượng", // translated 
  options: "Tùy chọn", // translated 
  departingAirport: "Sân bay khởi hành", // translated 
  childrenAreNotAllowedInThisTour: "Trẻ em không được phép tham gia tour này.", // translated 
};


export default product;
